'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridSelectionCellClassNames: function() {
        return dataGridSelectionCellClassNames;
    },
    useDataGridSelectionCellStyles_unstable: function() {
        return useDataGridSelectionCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableSelectionCellStylesstyles = require("../TableSelectionCell/useTableSelectionCellStyles.styles");
const dataGridSelectionCellClassNames = {
    root: 'fui-DataGridSelectionCell',
    checkboxIndicator: 'fui-DataGridSelectionCell__checkboxIndicator',
    radioIndicator: 'fui-DataGridSelectionCell__radioIndicator'
};
const useDataGridSelectionCellStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableSelectionCellStylesstyles.useTableSelectionCellStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridSelectionCellClassNames.root, state.root.className);
    if (state.checkboxIndicator) {
        state.checkboxIndicator.className = (0, _react.mergeClasses)(dataGridSelectionCellClassNames.checkboxIndicator, state.checkboxIndicator.className);
    }
    if (state.radioIndicator) {
        state.radioIndicator.className = (0, _react.mergeClasses)(dataGridSelectionCellClassNames.radioIndicator, state.radioIndicator.className);
    }
    return state;
};
